export const isValidNumber = value => /^[0-9]*\.?[0-9]*$/.test(value);

export const isValidSearchText = value => /^[a-zA-Z0-9-\s]+$/.test(value);